module.exports = __webpack_public_path__ + "static/media/Yenepoya Photos-6.097bb254.png";